module.exports = __webpack_public_path__ + "img/index-0.d218c0a7.jpg";